import { CartProduct, Product } from '@mc/api'

export const getLTVPriceValueFromProduct = (
  isGift: boolean,
  product: CartProduct | Product,
) => {
  const ltv = product.productLtv
  return isGift ? ltv?.gift : ltv?.regular
}
